(function () {
  var root = document.querySelector('[data-csc-cert-page]');
  if (!root) return;

  document.documentElement.dataset.csSuppressNewsletterPopup = 'true';
  window.CannaSelectionSuppressNewsletterPopup = true;
  var locale = (root.dataset.locale || document.documentElement.lang || 'de').split('-')[0];
  var copy = { de: { searching: 'Prüfstatus wird gesucht ...', failed: 'Der Prüfstatus konnte nicht geladen werden.', empty: 'Für diese Suche ist derzeit kein aktiver öffentlicher Prüfstatus hinterlegt.', active: 'aktiv', areas: 'Bereiche', standard: 'Standard', valid: 'Gültig bis', profile: 'Clubprofil im CSC-Finder ansehen', defaultScope: 'CSC Qualitätszertifizierung' }, en: { searching: 'Searching certification status ...', failed: 'The certification status could not be loaded.', empty: 'There is currently no active public certification status for this search.', active: 'active', areas: 'Areas', standard: 'Standard', valid: 'Valid until', profile: 'View club profile in the CSC Finder', defaultScope: 'CSC quality certification' }, es: { searching: 'Buscando el estado de certificación ...', failed: 'No se ha podido cargar el estado de certificación.', empty: 'Actualmente no hay un estado público activo para esta búsqueda.', active: 'activo', areas: 'Áreas', standard: 'Estándar', valid: 'Válido hasta', profile: 'Ver perfil del club en el buscador CSC', defaultScope: 'Certificación de calidad CSC' } }[locale] || {};

  function analyticsAllowed() {
    try {
      return !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed || window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    } catch (_) {
      return false;
    }
  }

  function event(name, detail) {
    if (!analyticsAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name, landing_path: location.pathname, page_kind: root.dataset.pageKind || '' }, detail || {}));
  }

  function enableFocusPlaceholder(input) {
    if (!input || input.dataset.csFocusPlaceholderReady) return;
    var placeholder = input.getAttribute('placeholder') || '';
    if (!placeholder) return;
    input.dataset.csFocusPlaceholderReady = 'true';
    input.addEventListener('focus', function () {
      if (!input.value) input.setAttribute('placeholder', '');
    });
    input.addEventListener('blur', function () {
      input.setAttribute('placeholder', placeholder);
    });
  }

  function enablePageSearchPlaceholders(scope) {
    (scope || document).querySelectorAll('input[type="search"][placeholder]').forEach(enableFocusPlaceholder);
  }

  enablePageSearchPlaceholders(document);
  root.querySelectorAll('[data-csc-cert-event]').forEach(function (link) {
    link.addEventListener('click', function () {
      var action = link.dataset.cscCertEvent;
      event(action === 'module_select' ? 'csc_cert_module_select' : 'csc_cert_' + action + '_click', { href: link.getAttribute('href') || '' });
    });
  });

  var register = root.querySelector('[data-csc-cert-register]');
  if (register) {
    var form = register.querySelector('[data-csc-cert-search]');
    var result = register.querySelector('[data-csc-cert-results]');
    var endpoint = register.dataset.endpoint;
    enableFocusPlaceholder(form && form.querySelector('input[type="search"]'));

    function esc(value) {
      return String(value || '').replace(/[&<>"']/g, function (character) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character];
      });
    }

    function profileLink(item) {
      if (!item.profile_url) return '';
      return '<a class="csc-cert__text-link" href="' + esc(item.profile_url) + '">' + copy.profile + '</a>';
    }

    form.addEventListener('submit', async function (eventObject) {
      eventObject.preventDefault();
      result.textContent = copy.searching;
      var parameters = new URLSearchParams(new FormData(form));

      try {
        var response = await fetch(endpoint + '?' + parameters.toString(), { headers: { Accept: 'application/json' } });
        var data = await response.json();
        if (!response.ok || !data.ok) throw new Error(data.error || copy.failed);
        event('csc_certificate_search', { q: parameters.get('q') || '' });

        if (!data.items.length) {
          result.textContent = copy.empty;
          event('csc_certificate_not_found');
          return;
        }

        result.innerHTML = data.items.map(function (item) {
          var modules = (item.modules || []).join(', ') || '-';
          var standard = item.standard_version || '-';
          var expiresAt = item.expires_at || '-';
          return '<article class="csc-cert__certificate"><h3>' + esc(item.club_name) + ' · ' + esc(item.certificate_number) + '</h3><span class="csc-cert__status csc-cert__status--aktiv">' + copy.active + '</span><p>' + esc(item.city || '') + ' · ' + esc(item.public_scope || copy.defaultScope) + '</p><p>' + copy.areas + ': ' + esc(modules) + '<br>' + copy.standard + ': ' + esc(standard) + ' · ' + copy.valid + ': ' + esc(expiresAt) + '</p>' + profileLink(item) + '</article>';
        }).join('');
        event('csc_certificate_found', { count: data.items.length });
      } catch (error) {
        result.textContent = error.message || copy.failed;
      }
    });
  }

  event('csc_cert_' + (root.dataset.pageKind || 'page') + '_view');
})();
